import React, { useState } from "react";
import { getVehiculoByPlaca, getVehiculoOracleByPlaca } from '../../services/Combustible/vehiculoService';
import { QRCodeCanvas } from "qrcode.react"
import { Vehiculo } from "../../types/vehiculo";
import Swal from "sweetalert2";

const GenerateQRCode: React.FC = () => {
    const [error, setError] = useState<string | null>(null);
    const [placa, setPlaca] = useState<string>('');
    const [vehicleData, setVehicleData] = useState<Vehiculo | null>(null);
    const [qrVisible, setQrVisible] = useState<boolean>(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPlaca(e.target.value);
    };

    const fetchVehicleData = async () => {
        setError(null);
        try {
            let data;
            data = await getVehiculoByPlaca(placa);
            if (!data[0]) {
                data = await getVehiculoOracleByPlaca(placa)
            }
            if (data[0]) {
                setVehicleData(data[0]);
                setQrVisible(true);
            } else {
                setVehicleData(null);
                setError("No se encontraron vehículos con la placa proporcionada.");
                setQrVisible(false);
                Swal.fire({
                    title: 'Error',
                    text: 'No se encontró el vehículo según placa digitada',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }

        } catch (error) {
            console.error('Error fetching vehicle data:', error);
            Swal.fire({
                title: 'Error',
                text: 'No se encontró el vehículo según placa digitada',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            setQrVisible(false);
        }
    };

    const printQRCode = () => {
        const qrCodeCanvas = document.querySelector("#qr-code canvas") as HTMLCanvasElement;
        if (qrCodeCanvas) {
            //Convertir el canvas a una URl de imagen
            const qrCodeImageURL = qrCodeCanvas.toDataURL("image/png");


            //Crear un iframe temporal
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'absolute';
            printFrame.style.top = '-10000px';
            printFrame.style.left = '-10000px';

            document.body.appendChild(printFrame);

            const frameDocument = printFrame.contentDocument || printFrame.contentWindow?.document;
            if (frameDocument) {
                frameDocument.open();
                frameDocument.write(`
                <html>
                <head>
                    <title>Imprimir Código QR</title>
                    <style>
                        body {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            height: 100vh;
                            margin: 0;
                        }
                        img {
                            width: 200px;
                            height: 200px;
                        }    
                        p {
                            text-align: center;
                            margin-top: 10px;
                            font-size: 16px;
                            font-weight: bold;
                        }    
                    </style>
                </head>
                <body>
                    <img src="${qrCodeImageURL}" alt="Código QR">
                    <p>${document.querySelector("#qr-code p")?.textContent}</p>
                </body>
                </html>
            `);
                frameDocument.close();

                // Esperar a que el contenido se cargue antes de imprimir
                printFrame.onload = () => {
                    printFrame.contentWindow?.print();
                    document.body.removeChild(printFrame);
                };
            }
        } else {
            console.error('QR code element not found.');
        }
    };


    // const printQRCodeBlankTab = () => {
    //     const qrCodeElement = document.getElementById('qr-code');
    //     if (qrCodeElement) {
    //         const printWindow = window.open('', '_blank');
    //         if (printWindow) {
    //             printWindow.document.write(`
    //                 <html>
    //                     <head>
    //                         <title>Imprimir Código QR</title>
    //                         <style>
    //                             body {
    //                                 display: flex;
    //                                 justify-content: center;
    //                                 align-items: center;
    //                                 height: 100vh;
    //                                 margin: 0;
    //                             }
    //                             #qr-code {
    //                                 text-align: center;
    //                             }
    //                         </style>
    //                     </head>
    //                     <body>
    //                         ${qrCodeElement.innerHTML}
    //                     </body>
    //                 </html>
    //             `);
    //             printWindow.document.close();
    //             printWindow.focus();
    //             printWindow.print();
    //         }
    //     }
    // };

    return (
        <div className="container mt-4">
            <div className="row">
                <div className="col-md-6 border-md">
                    <h2 className="mb-3">Generar Código QR</h2>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            fetchVehicleData();
                        }}
                    >
                        <label className="form-label" htmlFor="plate">Placa del Vehículo:</label>
                        <input
                            className="form-control mb-3"
                            type="text"
                            id="plate"
                            value={placa}
                            onChange={handleInputChange}
                            placeholder="Ingresa la placa"
                            required
                        />
                        <button className="btn btn-primary w-100 mb-3" type="submit">
                            Buscar
                            <i className="fa-solid fa-magnifying-glass ms-2"></i>
                        </button>
                        {/* Muestra errores */}
                        {error && <div className="alert alert-danger">{error}</div>}
                    </form>
                    {vehicleData && (
                        <div>
                            <h3>Datos del Vehículo</h3>
                            <p><strong>Placa:</strong> {vehicleData.Placa}</p>
                            <p><strong>Centro de Costos:</strong> {vehicleData.CentroCosto} - {vehicleData.CentroCostoDesc}</p>
                            <p><strong>Unidad:</strong> {vehicleData.NumeroUnidad}</p>
                            <p><strong>Marca/Modelo:</strong> {vehicleData.Marca} / {vehicleData.Modelo}</p>
                            <p><strong>Año:</strong> {vehicleData.Anno}</p>
                            {/* <p><strong>Departamento:</strong> {vehicleData.Departamento}</p>
                            <p><strong>Estado:</strong> {vehicleData.Estado}</p>
                            <p><strong>Motor:</strong> {vehicleData.Motor}</p>
                            <p><strong>Clindraje:</strong> {vehicleData.Cilindraje}</p>
                            <p><strong>Chasis:</strong> {vehicleData.Chasis}</p>
                            <p><strong>Tracción:</strong> {vehicleData.Traccion}</p>
                            <p><strong>Transmisión:</strong> {vehicleData.Transmision}</p>
                            <p><strong>Combustible:</strong> {vehicleData.Combustible}</p> */}
                        </div>
                    )}
                </div>
                <div className="col-md-6">
                    {qrVisible && (
                        <div id="qr-code" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <QRCodeCanvas
                                value={JSON.stringify(vehicleData?.Placa)}
                                size={200}
                            /* includeMargin={true} */
                            />
                            <p>{vehicleData!.Placa}</p>
                        </div>
                    )}
                    <button className="btn btn-success w-100" onClick={printQRCode} style={{ marginTop: '20px' }}>
                        Imprimir Código QR
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GenerateQRCode;